<template>
  <div class="friends">
    <div class="friends-container">
      <div class="friends-title">{{ $t("inviteFriends") }}</div>
      <!-- <p>mobile user id: {{this.mui}}</p>
            <p>email: {{this.email}}</p>
            <p>invite link all: {{this.sharing.url}}</p>
            <p>invite link wechat: {{this.config.url}}</p> -->

      <div class="two-boxes-container">
        <div class="downloadContainerOut">
          <div class="downloadContainerIn">
            <div class="downloadButton">
              <p>{{ $t("friends") }}</p>
              <p style="color: red">{{ this.recCount }}</p>
              <!-- <i class="fa fa-download" style="color: blue; font-size: 20px;" aria-hidden="true"></i> -->
            </div>
          </div>
          <div class="downloadContainerIn">
            <div class="downloadButton">
              <p>{{ $t("rewards") }}</p>
              <p style="color: red">${{ this.recCash }}</p>
              <!-- <i class="fa fa-download" style="color: blue; font-size: 20px;" aria-hidden="true"></i> -->
            </div>
          </div>
        </div>
      </div>

<div class="friend-text-container1">
 <p>{{ $t("friendstext1") }}</p>
</div>


      <div class="table-container">
        <el-table :data="recData" max-height="350">>
          <el-table-column
            property="email"
            :label="$t('friends')"
            min-width="120"
          ></el-table-column>

          <el-table-column :label="$t('status')" min-width="50">
            <template slot-scope="scope">
              <span style="color: green" v-if="scope.row.recommenderStatus">{{
                $t("success")
              }}</span>
              <span  style="color: #FF7900" v-if="!scope.row.recommenderStatus">{{
                $t("pending")
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>


<div class="friend-text-container2">
 <p>{{ $t("friendstext2") }}</p>
</div>

      <div class="sharing-container">
        <div class="sharing-pc">
          <img
            v-clipboard:copy="this.sharing.url"
            v-clipboard:success="copy"
            class="wechat-icon-container"
            src="../../assets/img/copy_icon.png"
          />
          <img
            @click="onClickShareWechat"
            class="wechat-icon-container"
            src="../../assets/img/wechat_icon.png"
          />
        </div>
        <ShareNetwork
          v-for="network in networks"
          :network="network.network"
          :key="network.network"
          :url="sharing.url"
          :title="sharing.title"
          :description="sharing.description"
          :quote="sharing.quote"
          :hashtags="sharing.hashtags"
          :twitterUser="sharing.twitterUser"
          @open="sharingClosed"
        >
          <!-- @open to @closed -->
          <img class="sharing-icon" :src="network.icon" alt />
        </ShareNetwork>
      </div>

      <div class="sharing-mobile">
        <img
          v-clipboard:copy="this.sharing.url"
          v-clipboard:success="copy"
          class="wechat-icon-container"
          src="../../assets/img/copy_icon.png"
        />
        <img
          @click="onClickShareWechat"
          class="wechat-icon-container wechat"
          src="../../assets/img/wechat_icon.png"
        />
      </div>
    </div>

    <transition name="modal" v-if="wechatModalOpen">
      <div class="modal-mask" @click="wechatModalOpen = false">
        <div class="modal-wrapper">
          <div class="modal-container99" @click.stop>
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import { mapActions, mapState, mapMutations } from "vuex";
import VueSocialSharing from "vue-social-sharing";
import Vue from "vue";

Vue.use(VueSocialSharing);

import Share from "vue-social-share";
Vue.use(Share);

import VueCryptojs from "vue-cryptojs";
Vue.use(VueCryptojs);
import fbicon from "../../assets/img/facebook_icon.png";
import twittericon from "../../assets/img/twitter_icon.png";
import pinteresticon from "../../assets/img/pinterest_icon.png";
import whatsappicon from "../../assets/img/whatsapp_icon.png";
import lineicon from "../../assets/img/line_icon.png";
// import wechaticon from "../../assets/img/wechat_icon.png";

// import Router from "../router";
// import { isUserAuthenticated } from "../store/modules/cart";
export default {
  name: "Friends",
  data() {
    return {
      inviteLink: "",
      mui: null,
      email: null,

      sharing: {
        // url: "https://afmstage-web.truckxi.com",
        url: "https://shopafm.com/referral",
        title:
          "I am inviting you to shopafm.com! Register with my link and get 20$ off first order. | 邀请您来 shopafm.com！用我的链接注册，首单减 $20！",
        // description: "Register with the referral link to receive rewards. | 需使用邀请路径注册得到奖励。",
        description: "",
        quote: "I am inviting you to shopafm.com! Register with my link and get 20$ off first order. | 邀请您来 shopafm.com！用我的链接注册，首单减 $20！",
        hashtags: "AFM",
        twitterUser: "",
      },

      wechatModalOpen: false,

      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: fbicon,
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: twittericon,
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: pinteresticon,
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: whatsappicon,
        },
        {
          network: "line",
          name: "Line",
          icon: lineicon,
        },
      ],
      config: {
        url: "https://shopafm.com/referral",
        title: "AFM",
        description: "AFM",
        sites: ["wechat"],
        wechatQrcodeTitle: "",
        wechatQrcodeHelper: "",
      },

      recCash: null,
      recCount: null,
      recData: [],

      encr: null,
      decr: null,
    };
  },
  methods: {
    ...mapActions("auth", ["fetchCustomerInformation"]),
    ...mapActions("profile", [
      "fetchFriendsData",
      "fetchSubscribeEmail",
      "postSubscribeEmail",
      "putUnsubscribeEmail",
      "fetchProductReviews",
      "submitProductReviews",
    ]),
    ...mapMutations("navbar", [
      "toggleLoginModalVisibility",
      "toggleRegisterModalVisibility",
    ]),
    continueShopping() {
      this.$router.push("/collections");
    },
    sharingClosed() {
      // localStorage.setItem('shareCreditUsed', true);
      // this.updateIsShareCreditUsed(true);
    },
    onClickShareWechat() {
      // this.shareModalOpen = false;
      this.wechatModalOpen = true;
    },
    copy() {
      this.$notify({
        type: "success",
        title: this.$t("invitelinkcopied"),
        position: "bottom-right",
        duration: 3000,
      });
    },
  },
  //   beforeRouteLeave(to, from, next) {
  //     next();
  //   },
  mounted() {
    this.$store.dispatch("auth/fetchCustomerInformation");
    this.fetchFriendsData();
  },
  watch: {
    $route(to, from) {},
    userDetails: function (newVal, oldVal) {
      if (newVal && newVal.mobile_user_id) {
        this.mui = newVal.mobile_user_id;
      }
      if (newVal && newVal.email) {
        this.email = newVal.email;
      }

      this.encr = this.CryptoJS.AES.encrypt(
        this.mui + "&&" + this.email,
        "x"
      ).toString();
      this.encr = this.encr
        .replace(/\+/g, "p1L2u3S")
        .replace(/\//g, "s1L2a3S4h")
        .replace(/=/g, "e1Q2u3A4l");

      // this.sharing.url = 'https://afmstage-web.truckxi.com/referral/' + this.mui + '&&' + this.email;
      // this.config.url = 'https://afmstage-web.truckxi.com/referral/' + this.mui + '&&' + this.email;
      this.sharing.url = "https://shopafm.com/referral/" + this.encr;
      this.config.url = "https://shopafm.com/referral/" + this.encr;
      //  this.encr = this.encr.replace(/p1L2u3S/g, '+' ).replace(/s1L2a3S4h/g, '/').replace(/e1Q2u3A4l/g, '=');
      //  this.decr = this.CryptoJS.AES.decrypt(this.encr, "x").toString(this.CryptoJS.enc.Utf8);
    },
    friendsData: function (newVal, oldVal) {
      if (newVal) {
        this.recCash = newVal.recommenderSuccessAmount;
        this.recCount = newVal.recommenderSuccessCounts;
        this.recData = newVal.recommenderlist;
      }
    },
  },
  computed: mapState({
    userDetails: (state) => state.auth.userDetails,
    friendsData: (state) => state.profile.friendsData,
  }),
};
</script>
​
<style scoped lang="less">
@import "../../assets/css/public";
@import "../../assets/css/inviteFriends";
@import "../../assets/css/modalNew.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/inviteFriends.vue